import React, { useEffect, useState } from 'react';
import { Card, Table, Pagination, message } from 'antd';
import { useSelector, useDispatch } from 'react-redux';
import { useInjectSaga } from 'utils/injectSaga';
import { useInjectReducer } from 'utils/injectReducer';
import reducer, { initialState } from './reducer';
import saga from './saga';
import _ from 'lodash';
import { toggleDrawer, toggleDeleteModal, listProductconf } from './action';
import clientReducer, { initialState as clientInitialState } from 'pages/Client/reducer';
import clientSaga from 'pages/Client/saga';
import productSaga from 'pages/Product/saga';
import productReducer, { initialState as productInitialState } from 'pages/Product/reducer';
import { ProductTableConfig } from './ProductConfigTable';
import AddProductConfigDrawer from 'components/AddProductConfigDrawer';
function ProductConfigDetails() {
  useInjectReducer({ key: 'productconf', reducer });
  useInjectSaga({ key: 'productconf', saga });
  useInjectReducer({ key: 'product', reducer: productReducer });
  useInjectSaga({ key: 'product', saga: productSaga });
  useInjectReducer({ key: 'client', reducer: clientReducer });
  useInjectSaga({ key: 'client', saga: clientSaga });
  const [columns, setColumns] = useState([]);
  const [searchText, setSearchText] = useState(null);
  const [searchedColumn, setSearchedColumn] = useState(null);
  const [deleteModalToggle, setDeleteModalToggle] = useState(false);
  const [selectedProductconf, setselectedProductconf] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const productconfState = useSelector((state) => state.productconf || initialState);
  const authState = useSelector((state) => state.auth);
  const dispatch = useDispatch();
  useEffect(() => {
    const columns = ProductTableConfig(
      handleSearch,
      handleReset,
      editUserProductconf,
      authState.userResponsibilities,
    );
    setColumns(columns);
    dispatch(listProductconf({ page: 1, limit: 10 }));
  }, []);

  const resetPagination = () => setCurrentPage(1);

  const editUserProductconf = (email) => {
    setselectedProductconf(email);
    dispatch(toggleDrawer());
  };

  const onPageChange = (page, pageSize) => {
    let filter = { page, limit: pageSize };
    setCurrentPage(page);
    if ((searchedColumn, searchText)) {
      filter = { ...filter, [searchedColumn]: searchText };
    }
    dispatch(listProductconf(filter));
  };

  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    if (selectedKeys.length <= 0) {
      message.error('Please select to search');
      return;
    }
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
    dispatch(listProductconf({ page: 1, limit: 10, [dataIndex]: selectedKeys[0] }));
    resetPagination();
  };
  // const handleDeleteModalToggle = () => dispatch(toggleDeleteModal());

  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText(null);
    setSearchedColumn(null);
    dispatch(listProductconf({ page: 1, limit: 10 }));
    resetPagination();
  };
  return (
    <>
      <Card
        title="Manage Product Configuration"
        extra={
          <AddProductConfigDrawer
            initialState={initialState}
            clientInitialState={clientInitialState}
            productInitialState={productInitialState}
            selectedProductconf={selectedProductconf}
            resetPagination={resetPagination}
            editUserProductconf={editUserProductconf}
            roleAddResponsibility={_.includes(authState.userResponsibilities, 'ADD_DEDICATED')}
          />
        }
      >
        <Table
          columns={columns}
          loading={productconfState.loading}
          bordered
          pagination={false}
          size={'small'}
          dataSource={productconfState.data}
          style={{ height: '70vh', overflow: 'scroll' }}
        />
        <Pagination
          style={{ marginTop: '10px' }}
          total={productconfState.totalCount}
          showTotal={(total) => `Total ${total} items`}
          defaultPageSize={10}
          current={currentPage}
          showLessItems={true}
          showSizeChanger={false}
          disabled={productconfState.loading}
          onChange={onPageChange}
        />
      </Card>
      {/* <ConfirmModal
        title={'Delete Portfolio Confirmation'}
        text={'Are you sure you want to delete this portfolio ?'}
        toggle={productconfState.deleteModal}
        loading={productconfState.loading}
        handleDeleteModalToggle={handleDeleteModalToggle}
        onDelete={onDelete}
      /> */}
    </>
  );
}

export default ProductConfigDetails;
